import { render, staticRenderFns } from "./donor-form.vue?vue&type=template&id=d519cb6e"
import script from "./donor-form.vue?vue&type=script&lang=js"
export * from "./donor-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports